export default "__VITE_ASSET__SQBeUigA__"